import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const calculateRate = (rateData) => {
  return api.post(URLS.rate, rateData, {
    headers: {
      needsToken: true
    }
  });
};

export const updateExistingRate = (rateData, id) => {
  return api.put(URLS.rate, rateData, {
    params: { id },
    headers: {
      needsToken: true
    }
  });
};

export const getRateById = (id) => {
  return api.get(`${URLS.rate}`, {
    params: { id },
    headers: {
      needsToken: true
    }
  });
};

export const getRates = (page = 1, limit = 15, filter) => {
  return api.post(URLS.rates, filter, {
    params: { page, limit },
    headers: {
      needsToken: true
    }
  });
};

export const getRatePdf = (id, offset, mapImage) => {
  return api.post(
    `${URLS.ratePdf}`,
    { mapImage, offset },
    {
      params: { id },
      headers: {
        needsToken: true
      },
      responseType: 'blob'
    }
  );
};

export const getRateXlsx = (id, offset) => {
  return api.post(
    `${URLS.rateExcel}`,
    {
      offset
    },
    {
      params: { id },
      headers: {
        needsToken: true
      },
      responseType: 'blob'
    }
  );
};

export const getCountiesList = (query, limit = 10) => {
  return api.get(URLS.countiesList, {
    params: { query, limit },
    headers: {
      needsToken: true
    }
  });
};

export const ratesBulkUpload = (formData) => {
  return api.post(URLS.ratesBulkUpload, formData, {
    headers: {
      needsToken: true
    }
  });
};

export const ratesBulkCreate = (data) => {
  return api.post(URLS.ratesBulkCreate, data, {
    headers: {
      needsToken: true
    }
  });
};

export const getRatesBulk = (id, data) => {
  return api.post(`${URLS.ratesBulk}`, data, {
    params: { id },
    headers: {
      needsToken: true
    }
  });
};

export const getBulkRatesPdf = (id, offset, sortBy, sortByOrder) => {
  return api.post(
    `${URLS.ratesPdf}`,
    { offset, sortBy, sortByOrder },
    {
      params: { id },
      headers: {
        needsToken: true
      },
      responseType: 'blob'
    }
  );
};

export const getBulkRatesExcel = (id, offset, sortBy, sortByOrder) => {
  return api.post(
    `${URLS.ratesExcel}`,
    { offset, sortBy, sortByOrder },
    {
      params: { id },
      headers: {
        needsToken: true
      },
      responseType: 'blob'
    }
  );
};
